import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import BrandMark from './BrandMark';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand">
              <img src="/logo-sdi.png" alt="SDI Tecnologia" />
            </Link>
            <p>
              Transformamos desafios tecnológicos em soluções estratégicas para empresas que buscam alta performance e segurança.
            </p>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="footer-title">Empresa</h4>
            <ul className="footer-links">
              <li><Link to="/sobre" className="footer-link">Sobre Nós</Link></li>
              <li><Link to="/historia" className="footer-link">Nossa História</Link></li>
              <li><Link to="/compromisso" className="footer-link">Compromisso</Link></li>
              <li><Link to="/contato" className="footer-link">Contato</Link></li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="footer-title">Soluções</h4>
            <ul className="footer-links">
              <li><Link to="/servicos" className="footer-link">Serviços de TI</Link></li>
              <li><Link to="/multiservicos" className="footer-link">Multisserviços</Link></li>
              <li><Link to="/resultados" className="footer-link">Resultados</Link></li>
            </ul>
          </div>

          {/* Legal/Contact Column */}
          <div>
            <h4 className="footer-title">Contato</h4>
            <ul className="footer-links">
              <li><a className="footer-link" href="tel:+5511964158980">+55 11 96415-8980</a></li>
              <li><a className="footer-link" href="mailto:contato.site@sditi.com.br">contato.site@sditi.com.br</a></li>
              <li><span className="footer-link">São Paulo, SP</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} <BrandMark /> Sistemas Digitais Inteligentes.</p>
      </div>
    </footer>
  );
};

export default Footer;
